import { ArrowsRightLeftIcon, BookOpenIcon } from '@heroicons/react/24/outline';
import { HandThumbUpIcon, NoSymbolIcon, UserIcon } from '@heroicons/react/24/solid';

const eventTypes: {
  [key: string]: { icon: React.ReactNode; bgColorClass?: string };
} = {
  statusChanged: {
    icon: <UserIcon className='h-5 w-5' />,
    bgColorClass: 'bg-gray-400',
  },
  submitted: {
    icon: <UserIcon className='h-5 w-5 text-neutralColor-normal' />,
    bgColorClass: 'bg-blue-500',
  },
  review: {
    icon: <BookOpenIcon className='h-5 w-5 text-secondaryColor-normal' />,
    bgColorClass: 'bg-blue-500',
  },
  denied: { icon: <NoSymbolIcon className='h-5 w-5 text-tertiaryColor-normal' /> },
  hold: { icon: <ArrowsRightLeftIcon className='h-5 w-5 text-cyan' /> },
  approved: {
    icon: <HandThumbUpIcon className='h-5 w-5 text-primaryColor-normal' />,
  },
};

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ');
}

export default function Timeline({ activity }: { activity: any }) {
  return (
    <section aria-labelledby='timeline-title' className='lg:col-start-3 lg:col-span-1'>
      <div className='bg-white shadow sm:rounded-lg divide-y'>
        <div className='py-5'>
          <h2
            id='timeline-title'
            className='text-lg px-6 py-2 font-medium text-gray-900 m-0 border-l-4 border-primaryColor-normal text-primaryColor-normal'
          >
            Timeline
          </h2>
        </div>

        {/* Activity Feed */}
        <div className='py-6 flow-root px-6'>
          <ul className='-mb-8'>
            <li>
              <div className='relative pb-8'>
                {false && <span className='absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200' aria-hidden='true' />}

                <div className='relative flex space-x-3'>
                  <div>
                    <span
                      className={classNames(
                        'h-8 w-8 bg-neutralColor-lightest rounded-full flex items-center justify-center ring-8 ring-white'
                      )}
                    >
                      {eventTypes.submitted.icon}
                    </span>
                  </div>
                  <div className='min-w-0 flex-1 pt-1.5 flex justify-between space-x-4'>
                    <div>
                      <p className='text-sm text-gray-500'>Application Received</p>
                    </div>
                    <div className='text-right text-sm whitespace-nowrap text-gray-500'>
                      <time dateTime={activity.createdAt}>{new Date(activity.createdAt).toDateString()}</time>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
